import "../scss/style.scss"
import jQuery from 'jquery';
// import "@babel/polyfill";
import initSwiper from "./swiper"
import initObserver from "./scroll"
import Modal from "./modal"
import Project from "./project"
import TopFunc from "./top"

(function($) {
  'use strict';
  new initSwiper()
  new initObserver()
  new Modal()
  new Project()
  new TopFunc()

  var $window  = $(window),
      $body    = $('#body'),
      $header  = $('#header');

  var windowW = $window.width(),
      windowH = $window.outerHeight(),
      headerHeight = $header.outerHeight(),
      isInit = true,
      isTouchDevice = false;


  // anchor link
  function scrollToAnker(hash) {
    var target = $(hash);
    var offset = ( windowW > 767 ) ? 30 : headerHeight;
    var position = target.offset().top - offset;
    $('body,html').stop().animate({scrollTop:position}, 400);
  }

  function anchorLink() {
    // // 遷移時にページ内リンクだったとき
    // var urlHash = location.hash;
    // if(urlHash) {
    //   $('body,html').stop().scrollTop(0);
    //   setTimeout(function () {
    //     //ロード時の処理を待ち、時間差でスクロール実行
    //     scrollToAnker(urlHash) ;
    //   }, 100);
    // }

    // $(document).on('click', 'a[href^="#"]', function(e) {
    //   e.preventDefault();
    //   var href = $(this).attr('href');
    //   if (href == "#" || href == "") {
    //     return;
    //   }
    //   scrollToAnker(href);

    //   return false;
    // });

  }

  function navControl() {
    var $menuBtn = $('.js-menuBtn');
    var $menu = $('.js-menu');
    var $menuItems = $('.js-menuItems').find('a');

    $menuBtn.on('click', function() {
      $menu.toggleClass('is-open');
      return false;
    });


    $menuItems.on( 'click', function(e) {
      $menu.toggleClass('is-open');
    });

    $menuItems.each(function () {
      var text = $(this).text();
      var html = '';
        text.split('').forEach(function (t, i) {
          if (t !== ' ') {
            html += '<span>' + t + '</span>';

          } else {
            html += t;
          }
        });
        $(this).html(html);
    });

  }

  function changeHeight() {
    windowH = $window.outerHeight();
    var newWindowW = $window.width();

    if ( newWindowW != windowW || isInit ) {
      if ( newWindowW <= 750 ) {
        $('.js-100vh').css('height', windowH);
        $('.js-min100vh').css('min-height', windowH);
      } else {
        $('.js-100vh').css('height', '');
        $('.js-min100vh').css('min-height', '');
      }
      windowW = $window.width();
      isInit = false;
    }
  }

  function toggleButton() {
    // <button class="js-toggle" data-target="" data-class="" data-type="add|remove">Toggle</button>
    $('.js-toggle').on('click', function(e) {
      var target    = $(this).data('target');
      var className = $(this).data('class');
      var type      = $(this).data('type');
      var tagName   = $(this).prop("tagName");

      if ( type == 'add') {
        $(target).addClass(className);
      }
      else if ( type == 'remove') {
        $(target).removeClass(className);
      }
      else {
        $(target).toggleClass(className);
      }

      if ( tagName == 'A' ) {
        return false;
      }
    });
  }

  function detectTouchDevice() {
    if (window.ontouchstart === null) {
      $('body').addClass('is-touch');
      isTouchDevice = true;
    }
  }

  function goTopAction() {
    var $gotop = $('.js-gotop');
    $gotop.on('click', function(event) {
      event.preventDefault();
      $gotop.addClass('is-clicked');
      $('html').css('scroll-behavior', 'auto');
      $('body,html').animate({
        scrollTop: 0
      }, 1000, function() {
        $('html').css('scroll-behavior', '');
        $gotop.removeClass('is-clicked');
      });
    });
  }

  function tabControl() {
    window.addEventListener("DOMContentLoaded", () => {
      const tabs = document.querySelectorAll('[role="tab"]');
      const tabList = document.querySelector('[role="tablist"]');

      if (!tabs || !tabList) return;

      // 各タブに click イベントハンドラーを追加します
      tabs.forEach((tab) => {
        tab.addEventListener("click", changeTabs);
      });

      // タブリストのタブ間の矢印ナビゲーションを有効にします
      let tabFocus = 0;

      tabList.addEventListener("keydown", (e) => {
        // 右に移動
        if (e.keyCode === 39 || e.keyCode === 37) {
          tabs[tabFocus].setAttribute("tabindex", -1);
          if (e.keyCode === 39) {
            tabFocus++;
            // 最後にいる場合は、最初に移動します
            if (tabFocus >= tabs.length) {
              tabFocus = 0;
            }
            // 左に移動
          } else if (e.keyCode === 37) {
            tabFocus--;
            // 最初にいる場合は、最後に移動します
            if (tabFocus < 0) {
              tabFocus = tabs.length - 1;
            }
          }

          tabs[tabFocus].setAttribute("tabindex", 0);
          tabs[tabFocus].focus();
        }
      });
    });

    function changeTabs(e) {
      e.preventDefault();
      const target = e.target;
      const selected = target.getAttribute("aria-controls");
      const selectedClass = target.getAttribute("data-target");
      const selectedPanel = document.querySelector(`#${selected}`);
      const selectedPanels = document.querySelectorAll(`.${selectedClass}`);
      const selectedPanelParent = selectedPanel.closest('.js-tabs');
      const scrollTargetId = target.getAttribute("data-scrollto");
      const scrollTarget = document.querySelector(`#${scrollTargetId}`) || selectedPanelParent;

      // タブから現在すべての選択状態を取り除きます
      selectedPanelParent
        .querySelectorAll('[aria-selected="true"]')
        .forEach((t) => t.setAttribute("aria-selected", false));

      // このタブを選択されたタブとして設定します
      selectedPanelParent
        .querySelectorAll(`[data-target="${selectedClass}"]`)
        .forEach((t) => t.setAttribute("aria-selected", true));

      // すべてのタブパネルを非表示にします
      selectedPanelParent
        .querySelectorAll('[role="tabpanel"]')
        .forEach((p) => p.setAttribute("hidden", true));

      // 選択されたパネルを表示します
      selectedPanels.forEach((p) => p.removeAttribute("hidden"));
      scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  anchorLink();
  navControl();
  changeHeight();
  toggleButton();
  detectTouchDevice();
  goTopAction();
  tabControl();

  var timer = false;
  $(window).on('resize', function() {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout( function() {
      changeHeight();
    } , 100);
  });

})(jQuery);
